"use client";

import { useEffect } from "react";
import { useInhomzTrack } from "./useInhomzTrack";

// Fires `eventRef` each time `isActive` turns true. For steps that stay
// mounted and slide in and out (EnquiryFlowShell), where mount != viewed.
export function useTrackWhenActive(isActive, eventRef, properties) {
  const track = useInhomzTrack();
  useEffect(() => {
    if (isActive) track(eventRef, properties);
    // Only the activation edge counts, not later prop changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);
}